<script lang="ts">
	import MarkdownContent from '$lib/components/docs/MarkdownContent.svelte';
	import type { PageData } from './$types';

	// Content is provided server-side (+page.server.ts) so the H1 is in the
	// prerendered HTML for crawlers.
	let { data }: { data: PageData } = $props();
	const content = $derived(data.content);
</script>

<svelte:head>
	<title>FAQ - Heyweek Documentation</title>
	<meta name="description" content="Frequently asked questions about Heyweek - find answers to common questions about features, billing, and support." />
	<meta property="og:title" content="FAQ - Heyweek Documentation" />
	<meta property="og:description" content="Frequently asked questions about Heyweek - find answers to common questions about features, billing, and support." />
</svelte:head>

<MarkdownContent {content} />